export default "__VITE_ASSET__Bbn9akf0__"